import {Card, Loader, Words, Word} from './style';

const LoadScreen = () => {
    return (
        <Card>
            <Loader>
                <p style={{display:'contents'}}>carregando</p>
                <Words>
                    <Word>quadros</Word>
                    <Word>cards</Word>
                    <Word>listas</Word>
                    <Word>checklists</Word>
                    <Word>comentários</Word>
                </Words>
            </Loader>

        </Card>
    );
};

export default LoadScreen;